import {emptyValidator, formValidator} from "../../validators";

const shiftUserValidationStatus = {
    shuUser:{
        validators: [emptyValidator()],
        name: "User",
    },
    shuStatus:{
        validators: [emptyValidator()],
        name: "Status",
    },
    shuActive:{
        validators: [emptyValidator()],
        name: "Active",
    }
};
export const shiftUserValidation = (userData) => {
    return formValidator(userData, shiftUserValidationStatus);
};

const shiftDetailsValidationStatus = {
    shiShift :{
        validators: [emptyValidator()],
        name: "Shift Name",
    },
    shiStart :{
        validators: [emptyValidator()],
        name: "Start Time",
    },
    shiEnd :{
        validators: [emptyValidator()],
        name: "End Time",
    },
    shiStatus :{
        validators: [emptyValidator()],
        name: "Status",
    },
    shiActive :{
        validators: [emptyValidator()],
        name: "Active",
    }

};

export const shiftDetailsValidation = (shiftData) => {
    return formValidator(shiftData, shiftDetailsValidationStatus);
};

const shiftActionsValidationStatus = {
    shaMasterStatus :{
        validators: [emptyValidator()],
        name: "Action Status",
    },
    shaStatus :{
        validators: [emptyValidator()],
        name: "Status",
    },
    shaActive :{
        validators: [emptyValidator()],
        name: "Active",
    }
}

export const shiftActionsValidation = (shiftActions) => {
    return formValidator(shiftActions, shiftActionsValidationStatus);
};
